import styled from 'styled-components'

import BaseColorPicker from './colorsInterface.base'

const ColorsInterface = styled(BaseColorPicker)`
  display: flex;
`

/** @component */
export default ColorsInterface



// WEBPACK FOOTER //
// ./src/modules/productTile/colorPicker/colorsInterface.js